// Breakpoint definitions
export const BP = {
    xs: {
        name: "xs",
        minWidth: 0
    },
    sm: {
        name: "sm",
        minWidth: 576
    },
    md: {
        name: "md",
        minWidth: 768
    },
    lg: {
        name: "lg",
        minWidth: 992
    },
    xl: {
        name: "xl",
        minWidth: 1200
    }
};

// Breakpoints as an array ordered from small to large
export const BP_ORDERED = Object.values(BP).sort((bp1, bp2) => {
    return bp1.minWidth - bp2.minWidth;
});

export const BP_NAME = BP_ORDERED.map((bp) => {
    return bp.name;
});
